import { ReactComponent as ArbIcon } from "assets/img/icons/arb-logo.svg";
import { ReactComponent as AvalancheIcon } from "assets/img/icons/avalanche_logo.svg";
import { ReactComponent as BscIcon } from "assets/img/icons/bsc.svg";
import { ReactComponent as BtcIcon } from "assets/img/icons/btc_chain_logo.svg";
import { ReactComponent as CardanoIcon } from "assets/img/icons/cardano_logo.svg";
import { ReactComponent as CronosIcon } from "assets/img/icons/cronos_logo.svg";
import { ReactComponent as EthIcon } from "assets/img/icons/eth-chain.svg";
import { ReactComponent as FantomIcon } from "assets/img/icons/fantom_logo.svg";
import { ReactComponent as LineaIcon } from "assets/img/icons/linea-chain.svg";
import { ReactComponent as OptimismIcon } from "assets/img/icons/optimism_logo.svg";
import { ReactComponent as PolygonIcon } from "assets/img/icons/polygon_logo.svg";
import { ReactComponent as SolanaIcon } from "assets/img/icons/solana_logo.svg";
import { ReactComponent as BaseIcon } from "assets/img/icons/token_base.svg";
import { ReactComponent as BeraIcon } from "assets/img/icons/token_berachain.svg";
import { ReactComponent as TronIcon } from "assets/img/icons/tron_logo.svg";
import { ReactComponent as SonicIcon } from "assets/img/icons/token_sonic.svg";
import { ReactComponent as ImmutableIcon } from "assets/img/icons/immutable-zkevm.svg";

export const networkIconMap: Record<string, React.FC> = {
  Ethereum: EthIcon,
  "BNB Smart Chain": BscIcon,
  Arbitrum: ArbIcon,
  Linea: LineaIcon,
  Base: BaseIcon,
  Avalanche: AvalancheIcon,
  Bitcoin: BtcIcon,
  Cardano: CardanoIcon,
  Cronos: CronosIcon,
  Fantom: FantomIcon,
  Optimism: OptimismIcon,
  Polygon: PolygonIcon,
  Solana: SolanaIcon,
  Tron: TronIcon,
  Berachain: BeraIcon,
  Sonic: SonicIcon,
  ImmutableZkEVM: ImmutableIcon,
  "Immutable zkEVM": ImmutableIcon,
  Immutable: ImmutableIcon,
};

export const getNetworkIcon = (networkName: string): React.FC | null => {
  return networkIconMap[networkName] || null;
};
